// Progressive enhancement: the underlying <form> already works as a normal
// POST to /cart/add without this file (browser navigates to the cart page).
// When JS is available, we intercept the submit and add the item via the
// Cart AJAX API instead, so the customer doesn't leave the product page.
class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form');
    this.submitButton = this.form.querySelector('[type="submit"]');
    this.form.addEventListener('submit', this.onSubmit.bind(this));

    this.quantityInput = this.form.querySelector('.quantity-stepper__input');
    this.form.querySelector('[data-quantity-decrease]')?.addEventListener('click', () => this.stepQuantity(-1));
    this.form.querySelector('[data-quantity-increase]')?.addEventListener('click', () => this.stepQuantity(1));
  }

  stepQuantity(direction) {
    const input = this.quantityInput;
    const min = Number(input.min) || 1;
    const max = input.max ? Number(input.max) : Infinity;
    const next = (Number(input.value) || min) + direction;

    input.value = Math.min(Math.max(next, min), max);
  }

  async onSubmit(event) {
    event.preventDefault();
    this.submitButton.disabled = true;

    const formData = new FormData(this.form);
    const cartDrawer = document.querySelector('cart-drawer');

    // Have Shopify hand back the cart drawer's HTML pre-rendered with the
    // new item already in it, in the same response as the add. cart-drawer
    // is rendered inside a section group, so it has a dynamic runtime ID
    // rather than its plain filename (see cart-drawer.liquid's comment).
    if (cartDrawer) {
      formData.append('sections', cartDrawer.sectionId);
    }

    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: formData,
      });

      const data = await response.json();

      if (data.status) {
        // Cart API errors (e.g. sold out between page load and add) come
        // back as a 4xx JSON body with a `status` field rather than a
        // network-level failure, so this isn't caught by the try/catch.
        this.showError(data.description || data.message);
        return;
      }

      if (cartDrawer) {
        // /cart/add.js only returns the line item that was just added, not
        // the cart totals, so a second lightweight call gets the item count
        // for the header bubble.
        const cartResponse = await fetch(window.Shopify.routes.root + 'cart.js');
        const cart = await cartResponse.json();
        cartDrawer.renderContents({ sections: data.sections, item_count: cart.item_count });
      } else {
        window.location = window.Shopify.routes.root + 'cart';
      }
    } catch (error) {
      // Network failure, or JS disabled reaching this far somehow: fall
      // back to the plain cart page rather than leaving the customer stuck.
      window.location = window.Shopify.routes.root + 'cart';
    } finally {
      this.submitButton.disabled = false;
    }
  }

  showError(message) {
    let errorEl = this.querySelector('.product-form__error');
    if (!errorEl) {
      errorEl = document.createElement('p');
      errorEl.className = 'product-form__error';
      this.form.prepend(errorEl);
    }
    errorEl.textContent = message;
  }
}

customElements.define('product-form', ProductForm);
